/* eslint-disable */
export default {
  cancel: '取消',
  confirm: '確認',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
